import axios from 'axios';
import cryptoJs from './CryptoJsService';
import AuthService from './AuthService';
import router from '../router';

const basePath = process.env.VUE_APP_API_URL;
const tokenItemName = 'tokenData';
const credenciales = {
    "grant_type": process.env.VUE_APP_API_GRANT_TYPE,
    "client_id": process.env.VUE_APP_API_CLIENT_ID,
    "client_secret": process.env.VUE_APP_API_CLIENT_SECRET
};
const config = {
    headers: { 'Content-Type': 'application/json' }
};

export default class AuthApiService {

    constructor() {
        this.authService = new AuthService();
        this.setUp = false;
    }

    bPath() {
        return basePath;
    }

    getTknNameStorage() {
        return tokenItemName;
    }

    setUpMicrosoftApp() {
        if(!this.setUp) {
            this.authService.setUpMicrosoftApp();
            this.setUp = true;
        }
    }

    async getAccessToken() {
        // si no hay el item en el storage no se ha hecho el auth con el api
        const tokenData = this.decryptLocalStorage();
        if(tokenData && tokenData.access_token && await this.validateToken(tokenData.access_token)) {
            return tokenData;
        }

        const response = await this.authService.getGraphToken();
        if(!response) {
            return null;
        }
        const newToken = response.accessToken;
        if(tokenData == null) {
            tokenData = {
                token_type: 'Bearer'
            };
        }
        tokenData.access_token = newToken;
        this.encryptLocalStorage(tokenData);
        return tokenData;
    }
    
    getDataLocalStorage() {
        const tokenData = this.decryptLocalStorage();
        return tokenData;
    }

    encryptLocalStorage(tokenData) {
        localStorage.setItem( tokenItemName, cryptoJs.encrypt(JSON.stringify(tokenData)) );
    }

    decryptLocalStorage() {
        return JSON.parse( cryptoJs.decrypt(localStorage.getItem(tokenItemName)) );
    }

    destroyStorage() {
        localStorage.clear();
    }

    getTokenSilent() {
        return this.authService.getSilentToken();
    }

    acquireTokenRedirect() {
        return this.authService.acquireTokenRedirect();
    }

    async validateToken(microsoftToken) {
        try {

            const tokenData = {
                token_type: 'Bearer',
                access_token: microsoftToken
            };
    
            const oHeaders = { headers: { 'Authorization': tokenData.token_type + ' ' + tokenData.access_token } };
            const identity = await axios.get(basePath + 'api/identity/profile', oHeaders);
    
            if(identity.data.data) {
                return true;
            }
    
            return false;
        } catch(error) {
            return false;
        }
    }

    async realizarAutenticacion(microsoftToken) {
        const tokenData = {
            token_type: 'Bearer',
            access_token: microsoftToken
        };
            
        const aService = new AuthService();
        const microsoftUser = aService.getUser();
        const oHeaders = { headers: { 'Authorization': tokenData.token_type + ' ' + tokenData.access_token } };
        const identity = await axios.get(basePath + 'api/identity/profile', oHeaders);
        tokenData.user = identity.data.data;
        tokenData.menu = null;
        if (tokenData.user != null) {
            const menuDetails = await axios.get(basePath + 'api/menu-usuario/' + tokenData.user.idPerfil, oHeaders);
            tokenData.menu = menuDetails.data.data;
            // buscar info en banner para actualizar el ID anahuac
            const respRua = await axios.get(basePath + 'api/usuario-rua/por-correo/' + microsoftUser.userName, oHeaders);
            const dataUserRUA = respRua.data.data;
            if (typeof dataUserRUA.idAnahuac != 'undefined' && dataUserRUA.idAnahuac != null) {
                const datosUsuario = { 'idAnahuac': dataUserRUA.idAnahuac };
                if (typeof dataUserRUA.campus != 'undefined' && dataUserRUA.campus != null) {
                    datosUsuario.campus = dataUserRUA.campus;
                }    
                axios.put(basePath + 'api/usuario/' + tokenData.user.id + '/actualiza-campus-idanahuac', datosUsuario, oHeaders);
            }
        }
        this.encryptLocalStorage(tokenData);
        return this.decryptLocalStorage();

    }

    buscarUsuarioBanner() {
        this.isLoading = true;
        var user = this.$AuthService.getUser()
        const correo = user.userName;
        this.$AuthApiService.getAccessToken().then(r => 
          this.$axios.get(process.env.VUE_APP_API_URL + 'api/usuario-rua/por-correo/' + correo, {
            headers: { 'Authorization': r.token_type + ' ' + r.access_token }
          })
          .then(response => {
            const data = response.data.data;
            this.usuario = data;
            if (this.usuario.campus == null) {
              this.sinCampus = true;
              this.obtenerCampus();
            }
            if (typeof this.usuario.nombre == 'undefined') {
              const usuarioNombre = this.separarNombre(user.name);
              this.usuario.nombre = usuarioNombre.nombre;
              this.usuario.apellidoPaterno = usuarioNombre.apellidoPaterno;
              this.usuario.apellidoMaterno = usuarioNombre.apellidoMaterno;
            }
            this.isLoading = false;
          })
          .catch(error => {
            console.log(error.response);
          })
        );
    }
}
